module.exports = __webpack_public_path__ + "img/visa_rupay.8c3a487c.png";